import React from 'react';

/**
 * Tab label with its keyboard shortcut underlined where the letter appears in the
 * translated text. If the letter is not in the label (e.g. "Resumen" for 'o'), the label
 * is shown as is; the shortcut still works. Slicing off the first letter garbled the
 * Spanish labels ("Oesumen", "Qotizaciones", "Cuientes").
 */
export function renderTabLabel(text, shortcutChar) {
  const index = text.toLowerCase().indexOf(shortcutChar.toLowerCase());
  if (index === -1) return <span>{text}</span>;
  return (
    <span>
      {text.substring(0, index)}<u>{text.charAt(index)}</u>{text.substring(index + 1)}
    </span>
  );
}
